import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

/** Clinic groups plus every Group Admin user — the Super Admin Clinic groups screen. */
export const getClinicGroupsApi = createAsyncThunk(
  'clinicGroups/get',
  async (_, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const res = await fetch(CLINICS.CLINIC_GROUPS_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch clinic groups');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
